var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit010(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2546 12.5771C2.28523 12.3014 2.30054 12.1636 2.34225 12.0347C2.37925 11.9205 2.43153 11.8117 2.49766 11.7114C2.57221 11.5983 2.67027 11.5003 2.86639 11.3042L11.6706 2.49998C12.407 1.7636 13.6009 1.7636 14.3373 2.49998C15.0736 3.23636 15.0736 4.43027 14.3373 5.16665L5.53306 13.9708C5.33694 14.1669 5.23888 14.265 5.12583 14.3396C5.02554 14.4057 4.91677 14.458 4.80247 14.495C4.67364 14.5367 4.53581 14.552 4.26015 14.5826L2.00391 14.8333L2.2546 12.5771Z",
    stroke: "#FFFF00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit010);
export default __webpack_public_path__ + "static/media/edit-010.9e665932617d2b5cfc9bdbe2451464ae.svg";
export { ForwardRef as ReactComponent };